import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Chapter } from "../components/Chapter";
import { RealScreen } from "../components/UIFragment";
import { IMG } from "../lib/scenes";

const EASE = [0.16, 1, 0.3, 1];

// Service — by the time it starts, the work is already done.
export const SceneService = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const winY = useTransform(scrollYProgress, [0, 1], ["5%", "-5%"]);

  return (
    <section
      id="service"
      data-scene
      ref={ref}
      className="relative px-6 py-14 md:px-12 md:py-24 lg:px-24"
    >
      <div className="mx-auto w-full max-w-[1600px]">
        <Chapter title="Service" />

        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-12 lg:gap-16">
          <div className="lg:col-span-6">
            <h2 className="font-display text-6xl font-black leading-[0.92] tracking-tighter text-[#1b1a18] sm:text-7xl">
              When service starts, you’re ready.
            </h2>
            <p className="mt-6 max-w-md font-body text-xl leading-relaxed text-[#6b665e]">
              Nothing left to chase. Everything in its place.
            </p>
          </div>

          <div className="lg:col-span-6">
            <div className="overflow-hidden rounded-2xl">
              <img
                src={IMG.service}
                alt="A chef plating a dish during service"
                className="aspect-[3/2] w-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>

        <motion.div
          style={{ y: winY }}
          initial={{ opacity: 0, scale: 0.98 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-12%" }}
          transition={{ duration: 0.9, ease: EASE }}
          className="mx-auto mt-10 w-full max-w-[1500px]"
        >
          <RealScreen
            src="/generated/real_dailychecks.webp"
            alt="MiseOne — Daily Checks: food-safety checks completed before service"
            testId="service-app-screenshot"
          />
        </motion.div>
      </div>
    </section>
  );
};
